import { useState, useEffect, useRef } from 'react';

/**
 * Animasyonlu arka plan için özel hook
 * @param {boolean} isEnabled - Animasyonun etkin olup olmadığı
 * @returns {Object} Animasyon durumu ve referanslar
 */
const useAnimatedBackground = (isEnabled = true) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const ringRef = useRef(null);

  // Fare hareketiyle animasyonu takip et
  useEffect(() => {
    if (!isEnabled) return;
    
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const { innerWidth, innerHeight } = window;
      
      // Ekran ortasına göre göreceli hareket
      const moveX = (clientX - innerWidth / 2) / 30;
      const moveY = (clientY - innerHeight / 2) / 30;
      
      setMousePosition({ x: moveX, y: moveY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [isEnabled]);

  // Dokunmatik cihazlar için hareket dinleyicisi
  useEffect(() => {
    if (!isEnabled) return;
    
    const handleTouchMove = (e) => {
      if (!e.touches[0]) return;
      
      const { clientX, clientY } = e.touches[0];
      const { innerWidth, innerHeight } = window;
      
      // Ekran ortasına göre göreceli hareket
      const moveX = (clientX - innerWidth / 2) / 30;
      const moveY = (clientY - innerHeight / 2) / 30;
      
      setMousePosition({ x: moveX, y: moveY });
    };

    window.addEventListener('touchmove', handleTouchMove);
    return () => window.removeEventListener('touchmove', handleTouchMove);
  }, [isEnabled]);

  // Halkaların hareket stili
  const ringStyle = {
    transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`,
    transition: 'transform 0.3s ease-out'
  };

  return {
    mousePosition,
    ringRef,
    ringStyle
  };
};

export default useAnimatedBackground;